var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgApi = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 161.25 176.25"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".API_svg__cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:11.25px}"))), /*#__PURE__*/React.createElement("g", {
  id: "API_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "API_svg___\\xCE\\xD3\\xC8_1",
  "data-name": "\\u2014\\xCE\\xD3\\xC8_1"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "API_svg__cls-1",
  d: "M155.63 50.63h-45v-45"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "API_svg__cls-1",
  d: "M95.63 125.63h60v-75l-45-45h-45v60"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "API_svg__cls-1",
  d: "M95.63 95.63h-45v-45"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    strokeLinecap: "square",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: "11.25px"
  },
  d: "M5.63 50.63v120h90v-75l-45-45h-45z"
}))));
export default SvgApi;